export const TableHelpers = {
    data() {
        return {
            // Certificación - Productos
            OCPR: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Producto, Proceso o Servicio',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría de producto, Proceso o Servicio',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Documento normativo',
                    type: 'custom-html',
                    key: 'level_6_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Modificatorias a los Documentos Normativos',
                    type: 'text',
                    key: 'level7',
                },
                {
                    title: 'Tipo de esquema de certificación',
                    type: 'custom-html',
                    key: 'level_8_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Especificación técnica',
                    type: 'text',
                    key: 'level9',
                },
            ],
            // Certificación - Sistemas de Gestión Antisoborno
            CSGAS: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
            ],
            // Certificación - Sistemas de Gestión de Calidad y Certificación de Sistemas de Gestión Ambiental
            OCSG: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Sector IAF',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
            ],
            // Certificación - Sistemas de Gestión de la Inocuidad Alimentaria
            CSIA: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Grupo',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Subcategoría',
                    type: 'custom-html',
                    key: 'level_7_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Documento normativo específico para FSSC',
                    type: 'custom-html',
                    key: 'level_8b',
                    modifier: (item) => {
                        return item.value;
                    }
                },
            ],
            // Certificación - Personas
            OCPE: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Personal certificado',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría de personal',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Documento normativo',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Esquema de certificaciòn de personas',
                    type: 'text',
                    key: 'level7',
                },
            ],
            // Inspección
            OINSP: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Campo de inspección/alcance',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Elemento a inspeccionar',
                    type: 'custom-html',
                    key: 'level_4_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Tipo de inspección o metodología',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Tipo de Organismo en base a la independencia (A,B,C)',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Procedimientos de Inspección',
                    type: 'custom-html',
                    key: 'level7',
                    modifier: (value) => {
                        return value;
                    }
                },
                {
                    title: 'Código tipo de la norma o especificación técnica/Vigencia de la norma o especificación técnica (Año de publicación, reafirmación, edición/revisión (cuando aplique))',
                    type: 'custom-html',
                    key: 'level8',
                    modifier: (value) => {
                        return value;
                    }
                },
            ],
            // Laboratorio - Ensayos / Investigación y Control de Calidad
            OENY: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Campo',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Técnica',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Ensayo',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Producto',
                    type: 'custom-html',
                    key: 'level_7_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Rango',
                    type: 'text',
                    key: 'level8',
                },
                {
                    title: 'Método Interno',
                    type: 'text',
                    key: 'level9',
                },
                {
                    title: 'Método Referencia',
                    type: 'text',
                    key: 'level10',
                },
            ],
            // Laboratorio - Clínico
            OCLN: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Campo',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Técnica',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Ensayo',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Muestra',
                    type: 'custom-html',
                    key: 'level_7_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Rango',
                    type: 'text',
                    key: 'level8',
                },
                {
                    title: 'Método',
                    type: 'text',
                    key: 'level9',
                },
                {
                    title: 'Método Referencia',
                    type: 'text',
                    key: 'level10',
                },
            ],
            // Laboratorio - Calibración
            OEYC: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Área Calibración',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Magnitud',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Instrumento',
                    type: 'custom-html',
                    key: 'level_6_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Intervalo',
                    type: 'text',
                    key: 'level7',
                },
                {
                    title: 'Incertidumbre',
                    type: 'text',
                    key: 'level8',
                },
                {
                    title: 'Método Interno',
                    type: 'custom-html',
                    key: 'level9',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Método Referencia',
                    type: 'custom-html',
                    key: 'level10',
                    modifier: (item) => {
                        return item;
                    }
                },
            ],
            // Laboratorio - Proveedores de Ensayos de Aptitud
            OEAP: [{
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Programa',
                    type: 'custom-html',
                    key: 'level7',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Ensayo / Magnitud',
                    type: 'custom-html',
                    key: 'level8',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Ítem de Ensayo de Aptitud',
                    type: 'custom-html',
                    key: 'level9',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Frecuencia',
                    type: 'custom-html',
                    key: 'level10',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Método para el Valor',
                    type: 'custom-html',
                    key: 'level11',
                    modifier: (item) => {
                        return item;
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}